<div>
  <nav class="nav-btn">
    <button class="btn" (click)="this.activeMaintenanceMessageClicked();" [ngClass]="{ 'active': this.isActiveMaintenanceMessageActive}">Active maintenance message</button>
    <button class="btn" (click)="this.maintenanceMessageclicked()" [ngClass]="{ 'active': this.isMaintenanceMessageActive }">Maintenance message list</button>
    <button class="btn" (click)="this.maintModeClicked()" [ngClass]="{ 'active': this.isSetMaintModeActive }">Set maint-mode</button>
  </nav>

  <!-- Section used to list the active maintenance messages -->
  @if(this.isActiveMaintenanceMessageActive){
    <section>
      <table class="table-list">
        <thead>
          <tr>
            <th>
              Alert type
            </th>
            <th>
              Active messages
            </th>
          </tr>
        </thead>
        <tbody>
          @for(item of this.manageService.activeMaintenanceMessageArray; let i = $index; track item){
            <tr>
              <td [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                {{ item.message_alert_type }}
              </td>
              <td class="valueItem" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                <a (click)="this.manageService.openMaintenanceMessageModal(item.message_key, item.message_id, item.message_alert_type, item.message_fr, item.date_time_from, item.date_time_to, item.servers);
                            this.manageService.isUpdateMaintenanceMessageActive = true;">
                  <div><strong>FR:</strong> {{ item.message_fr }}</div>
                  <div class="en-div"><strong>EN:</strong> {{ item.message_en }}</div>
                </a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }


<!-- Section for maintenance message list -->
  @if(this.isMaintenanceMessageActive){
    <section>
      <table class="table-list">
        <thead>
          <tr>
            <th>
              Key
            </th>
            <th>
              Value ( FR / EN )
            </th>
            <th class="add-message">
              <a (click)="this.createMaintenanceMessageClicked()">+ Add message</a>
            </th>
          </tr>
        </thead>
        <tbody>
          @for(item of this.manageService.maintenanceMessageList; let i = $index; track item){
            <tr>
              <td class="keyItem" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                {{ item.message_key }}
              </td>
              <td class="valueItem" colspan="2" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                <a (click)="this.manageService.openMaintenanceMessageModal(item.message_key);
                            this.manageService.isSetupMaintenanceMessageActive = true;">
                  <div><strong>FR:</strong> {{ item.message_fr }}</div>
                  <div class="en-div"><strong>EN:</strong> {{ item.message_en }}</div>
                </a>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }

  <!-- Section for server maint-mode list -->
  @if(this.isSetMaintModeActive){
    <section>
      <table class="table-list">
        <thead>
          <tr>
            <th>
              Server name
            </th>
            <th>
              Status
            </th>
            <th class="th-action">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          @for(item of this.manageService.serversInfoList; let i = $index; track item){
            <tr>
              <td [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                {{ item.name }}
              </td>
              <td [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                @if(item.maint_mode === 1){
                  <label>
                    In Maintenance
                  </label>
                }
                @else{
                  <label>
                    Running
                  </label>
                }
              </td>
              <td class="td-button-set-maint-mode" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
                @if(item.maint_mode === 0){
                  <button class="btn table-button" (click)="this.manageService.setServerInMaintMode(item.name, 1)">Set Maint-mode</button>
                }
                @else{
                  <button class="btn table-button" (click)="this.manageService.setServerInMaintMode(item.name, 0)">Remove Maint-mode</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }

</div>
<!-- Modal pop-up -->
@if(this.manageService.showManageModal){
  <app-manage-modal class="manage-modal" [ngClass]="{ 'modal-active' : this.manageService.showManageModal }"></app-manage-modal>
}
